import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import myAxios from '../AxiosUrl';
import styles from './EditOrder.module.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
function EditOrder() {
    const location = useLocation();
    // Team members edit from /edit-team-order and return to /team-order
    const backPath = location.pathname.startsWith('/edit-team-order') ? '/team-order' : '/order-list';
    const navigate = useNavigate();
    const [cName, setcName] = useState(location.state.cName || '');
    const [mobile, setMobile] = useState(location.state.cMobile || '');
    const [address, setAddress] = useState(location.state.address || '');
    const [status, setStatus] = useState(Number(location.state.orderStatus));
    const [totalPrice, setTotalPrice] = useState(location.state.totalPrice);
    const [advance, setAdvance] = useState(location.state.advance);
    const [discount, setDiscount] = useState(location.state.discount);
    const [privateNote, setPrivateNote] = useState(location.state.privateNote);
    const [OrderNote, setOrderNote] = useState(location.state.OrderNote);
    const [loading, setLoading] = useState(false);

    const [deliveryCharge, setDeliveryCharge] = useState(
        location.state.deliveryCharge
    );

    const submitH = async (e) => {
        setLoading(true);
        e.preventDefault();
        if (!cName || !mobile || !address || !status || !deliveryCharge) {
            toast.error('All Value Require');
            return;
        }

        const url = `edit-order/${location.state._id}`;
        const formData = {
            cName,
            mobile,
            address,
            status,
            privateNote,
            deliveryCharge,
            totalPrice,
            advance,
            discount,
            OrderNote,
        };

        myAxios
            .post(url, formData)
            .then((res) => {
                setLoading(false);
                navigate(backPath);
                toast.success(res.data.message);
            })
            .catch((error) => {
                setLoading(false);
                console.log(error);
            });
    };

    return (
        <div className={styles.pageContainer}>
            <ToastContainer />
            <div className={styles.pageCard}>
                {/* Header Section */}
                <div className={styles.header}>
                    <h1 className={styles.pageTitle}>Edit Order</h1>
                    <p className={styles.pageSubtitle}>
                        Update order details and customer information
                    </p>
                </div>

                {/* Form Content */}
                <div className={styles.formContent}>
                    {/* Order Products Display */}
                    <div className={styles.formSection}>
                        <h3 className={styles.sectionTitle}>Order Items</h3>
                        <div className={styles.productDisplay}>
                            {location.state.orderData.map((data, index) => (
                                <div className={styles.productItem} key={index}>
                                    <img
                                        height="50px"
                                        width="50px"
                                        src={data.image}
                                        alt="product"
                                    />
                                    <p>Quantity: {data.quantity}</p>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* Product Details */}
                    <div className={styles.formSection}>
                        <h3 className={styles.sectionTitle}>Product Details</h3>
                        <div className={styles.productDetailsList}>
                            {location.state.product.map((data, index) => (
                                <p key={index}>
                                    {data.Quality} Pcs • {data.pCode} • Color: {data.color}
                                </p>
                            ))}
                        </div>
                    </div>

                    {/* Delivery Location */}
                    <div className={styles.deliverySection}>
                        <label className={styles.deliveryLabel}>Delivery Location</label>
                        <div className={styles.deliveryButtons}>
                            <button
                                className={`${styles.deliveryButton} ${
                                    deliveryCharge === 'dhaka' ? styles.deliveryButtonActive : ''
                                }`}
                                onClick={() => setDeliveryCharge('dhaka')}
                            >
                                Inside Dhaka
                            </button>
                            <button
                                className={`${styles.deliveryButton} ${
                                    deliveryCharge === 'outside' ? styles.deliveryButtonActive : ''
                                }`}
                                onClick={() => setDeliveryCharge('outside')}
                            >
                                Outside Dhaka
                            </button>
                        </div>
                    </div>

                    {/* Customer Information */}
                    <div className={styles.formSection}>
                        <h3 className={styles.sectionTitle}>Customer Information</h3>

                        <div className={styles.formGroup}>
                            <label className={styles.formLabel} htmlFor="cName">
                                Customer Name *
                            </label>
                            <input
                                onChange={(e) => setcName(e.target.value)}
                                type="text"
                                className={styles.formInput}
                                id="cName"
                                placeholder="Enter customer name"
                                value={cName}
                                required
                            />
                        </div>

                        <div className={styles.formGroup}>
                            <label className={styles.formLabel} htmlFor="mobile">
                                Mobile Number *
                            </label>
                            <input
                                onChange={(e) => setMobile(e.target.value)}
                                type="number"
                                className={styles.formInput}
                                id="mobile"
                                placeholder="Enter mobile number"
                                value={mobile}
                                required
                            />
                        </div>

                        <div className={styles.formGroup}>
                            <label className={styles.formLabel} htmlFor="address">
                                Address *
                            </label>
                            <input
                                onChange={(e) => setAddress(e.target.value)}
                                type="text"
                                className={styles.formInput}
                                id="address"
                                placeholder="Enter delivery address"
                                value={address}
                                required
                            />
                        </div>
                    </div>

                    {/* Order Details */}
                    <div className={styles.formSection}>
                        <h3 className={styles.sectionTitle}>Order Details</h3>

                        <div className={styles.formGroup}>
                            <label className={styles.formLabel} htmlFor="totalPrice">
                                Total Price (৳)
                            </label>
                            <input
                                onChange={(e) => setTotalPrice(e.target.value)}
                                type="number"
                                className={styles.formInput}
                                id="totalPrice"
                                placeholder="Enter total price"
                                value={totalPrice}
                                required
                            />
                        </div>

                        <div className={styles.formGroup}>
                            <label className={styles.formLabel} htmlFor="advance">
                                Advance (৳)
                            </label>
                            <input
                                onChange={(e) => setAdvance(e.target.value)}
                                type="number"
                                className={styles.formInput}
                                id="advance"
                                placeholder="Enter advance amount"
                                value={advance}
                            />
                        </div>

                        <div className={styles.formGroup}>
                            <label className={styles.formLabel} htmlFor="discount">
                                Discount (৳)
                            </label>
                            <input
                                onChange={(e) => setDiscount(e.target.value)}
                                type="number"
                                className={styles.formInput}
                                id="discount"
                                placeholder="Enter discount amount"
                                value={discount}
                            />
                        </div>

                        {status !== 5 && (
                            <div className={styles.formGroup}>
                                <label className={styles.formLabel} htmlFor="status">
                                    Order Status
                                </label>
                                <select
                                    name="status"
                                    className={styles.statusSelect}
                                    id="status"
                                    onChange={(e) => setStatus(Number(e.target.value))}
                                    value={status}
                                >
                                    <option value="1">New</option>
                                    <option value="2">Call Done</option>
                                    <option value="7">Call Not-Received</option>
                                    <option value="8">Ask-Advance</option>
                                    <option value="9">Ship-Later</option>
                                    <option value="10">Waiting</option>
                                    <option value="12">Delivery-Issue</option>
                                    <option value="13">Payment-Received</option>
                                    <option value="3">Courier Done</option>
                                    <option value="4">Print Done</option>
                                    <option value="11">Overseas</option>
                                    <option value="5">Cancel</option>
                                    <option value="6">Return</option>
                                </select>
                            </div>
                        )}
                    </div>

                    {/* Notes */}
                    <div className={styles.formSection}>
                        <h3 className={styles.sectionTitle}>Notes (Optional)</h3>

                        <div className={styles.formGroup}>
                            <label className={styles.formLabel} htmlFor="privateNote">
                                Private Note
                            </label>
                            <input
                                onChange={(e) => setPrivateNote(e.target.value)}
                                type="text"
                                className={styles.formInput}
                                id="privateNote"
                                placeholder="Add a private note (not visible to customer)"
                                value={privateNote}
                            />
                        </div>

                        <div className={styles.formGroup}>
                            <label className={styles.formLabel} htmlFor="orderNote">
                                Order Note
                            </label>
                            <input
                                onChange={(e) => setOrderNote(e.target.value)}
                                type="text"
                                className={styles.formInput}
                                id="orderNote"
                                placeholder="Add a note for this order"
                                value={OrderNote}
                            />
                        </div>
                    </div>
                </div>

                {/* Form Actions */}
                <div className={styles.formActions}>
                    <button
                        onClick={submitH}
                        className={styles.primaryButton}
                        disabled={loading}
                    >
                        {loading ? 'Updating...' : 'Update Order'}
                    </button>
                    <button
                        onClick={() => navigate(backPath)}
                        className={styles.secondaryButton}
                        disabled={loading}
                    >
                        Cancel
                    </button>
                </div>
            </div>
        </div>
    );
}

export default EditOrder;
